export const DEFAULT_FPS = 16

export const MAX_PREVIEW_HEIGHT = 450
export const MAX_PREVIEW_WIDTH = 750

export const OVERLAY_TRANSITION_DURATION = 300 // in milliseconds
